const scriptKonduto = `
    var visitorID; 
    (function () {
      var period = 300;
      var limit = 20 * 1e3;
      var nTry = 0;
      var intervalID = setInterval(function () {
        var clear = limit / period <= ++nTry;
        if ((typeof (Konduto) !== "undefined") &&
          (typeof (Konduto.getVisitorID) !== "undefined")) {
          visitorID = window.Konduto.getVisitorID();
          localStorage.setItem("visitorID", visitorID);
          clear = true;
        }
        if (clear) {
          clearInterval(intervalID);
        }
      }, period);
    })(visitorID);`

const CheckoutConsts = {
  scriptKonduto,
}

export default CheckoutConsts
